import React, { useState, useMemo } from "react"
import { assignEmployee, dismissEmployee } from "../../axios/api/apiModule"
import { useDispatch } from "react-redux"
import { openToastify } from "../store/actions/toastifyAction"
import { REDUX_TOASTIFY_DEFAULTS } from "../store/config"

const AssignEmployeeModal = ({
  employees = [],
  selectedEmployees = [],
  bookingId,
  onClose,
  onAssign,
}) => {
  const [selected, setSelected] = useState(
    (selectedEmployees || []).map((e) => e.empId),
  )
  const [search, setSearch] = useState("")
  const dispatch = useDispatch()

  const filteredEmployees = useMemo(() => {
    console.log(employees)
    console.log(selected)

    if (!search) return employees

    return employees.filter((emp) =>
      `${emp.name} ${emp.empId} ${emp.email}`
        .toLowerCase()
        .includes(search.toLowerCase()),
    )
  }, [employees, search])

  const toggleEmployee = (emp) => {
    const exists = selected.includes(emp.empId)

    if (exists) {
      setSelected(selected.filter((id) => id !== emp.empId))
    } else {
      setSelected([...selected, emp.empId])
    }
  }

  const handleAssign = async () => {
    try {
      const prevAssigned = selectedEmployees.map((e) => e.empId)

      const assignIds = selected.filter((id) => !prevAssigned.includes(id))
      const dismissIds = prevAssigned.filter((id) => !selected.includes(id))

      // ASSIGN NEW EMPLOYEES
      if (assignIds.length > 0) {
        await assignEmployee({
          shortBookingId: bookingId,
          empIds: assignIds,
        })
      }

      // DISMISS REMOVED EMPLOYEES
      if (dismissIds.length > 0) {
        await dismissEmployee({
          shortBookingId: bookingId,
          empIds: dismissIds,
        })
      }

      dispatch(
        openToastify(
          "Employees updated successfully",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_SUCCESS(),
        ),
      )

      onAssign({ bookingId, selected })
      onClose()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl flex flex-col max-h-[90vh]">
        {/* HEADER */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-800">
            Assign Employees To #{bookingId}
          </h2>

          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full border hover:bg-gray-100"
          >
            ✕
          </button>
        </div>

        {/* SEARCH */}
        <div className="px-6 pt-4">
          <input
            type="text"
            placeholder="Search employee..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full h-11 px-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400"
          />
        </div>

        {/* EMPLOYEE LIST */}
        <div className="p-6 overflow-y-auto flex-1">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {filteredEmployees.map((emp) => {
              const active = selected.includes(emp.empId)

              return (
                <div
                  key={emp._id}
                  onClick={() => toggleEmployee(emp)}
                  className={`cursor-pointer rounded-xl border p-4 transition-all
                    
                    ${
                      active
                        ? "border-yellow-500 bg-yellow-50 shadow-md"
                        : "border-gray-200 hover:border-yellow-400 hover:shadow"
                    }`}
                >
                  {/* TOP */}
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-yellow-500 text-white flex items-center justify-center font-semibold">
                      {emp.name.charAt(0)}
                    </div>

                    <div className="flex flex-col">
                      <span className="font-medium text-gray-800">
                        {emp.name}
                      </span>

                      <span className="text-xs text-gray-500">{emp.empId}</span>
                    </div>
                  </div>

                  {/* ROLE BADGE */}
                  <div className="mt-3 flex items-center justify-between">
                    <span
                      className={`text-xs px-2 py-1 rounded-full ${
                        emp.role === "manager"
                          ? "bg-purple-100 text-purple-700"
                          : "bg-blue-100 text-blue-700"
                      }`}
                    >
                      {emp.role}
                    </span>

                    {active && (
                      <span className="text-yellow-600 text-sm font-medium">
                        ✓ Selected
                      </span>
                    )}
                  </div>

                  {/* CONTACT */}
                  <div className="mt-3 text-xs text-gray-500 space-y-1">
                    <div>📞 {emp.phoneNumber}</div>

                    <div className="truncate">✉ {emp.email}</div>
                  </div>
                </div>
              )
            })}
          </div>

          {filteredEmployees.length === 0 && (
            <div className="text-center text-gray-500 py-10">
              No employees found
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="flex items-center justify-between border-t px-6 py-4">
          <span className="text-sm text-gray-600">
            {selected.length} employee(s) selected
          </span>

          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
            >
              Cancel
            </button>

            <button
              onClick={handleAssign}
              disabled={!selected.length}
              className="px-5 py-2 rounded-lg bg-yellow-500 text-white font-medium hover:bg-yellow-600 disabled:opacity-50"
            >
              Assign Employees
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssignEmployeeModal
